import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbarContext } from '../../../contexts/Snackbar';
import { useMobile } from '../../../hooks/useMobile';
import { useLinesContext } from '../../../contexts/Lines';
import { useCompanyContext } from '../../../contexts/Company';
import { useOnboardingContext } from '../../../contexts/Onboarding';
import { useEventTrackerContext } from '../../../contexts/EventTracker';
import { ReactComponent as WelcomeAboardIcon } from '../../../../public/icons/welcome-aboard.svg';
import {
  submitNewApplication,
  setOnboardingComplete,
  pathname,
  lineStatus,
} from '../../../utils';
import messages from '../../../messages';
import Step from '../BuildingBlocks/Stepper/Step';
import { ESellerStore } from 'frontend/src/Types/business';

const SUBMIT_MESSAGE = 'Submitted during mobile onboarding.';

export default function MobileSubmitApp() {
  const mobile = useMobile('sm');
  const history = useHistory();
  const snackbar = useSnackbarContext();
  const { setLoading } = useOnboardingContext();
  const { business } = useCompanyContext();
  const { lines, setLines } = useLinesContext();
  const { trackEvent } = useEventTrackerContext();

  async function handleSubmit() {
    setLoading(true);
    try {
      const lineIds = lines
        ?.filter((line) => line.status === lineStatus.draft)
        .map((line) => line.id);
      await submitNewApplication(
        lineIds,
        business,
        SUBMIT_MESSAGE,
        null,
        trackEvent,
      );
      await setOnboardingComplete(trackEvent);
      setLines(null);
      if (business && business.sellerStore === ESellerStore.amazon) {
        history.push(`${pathname.connectAccounts.url}?expand=bank`);
      } else {
        history.push(pathname.connectAccounts.url);
      }
    } catch (error) {
      snackbar.show(messages.onboarding.errors.mobileSubmitApp, 'error');
    }
    setLoading(false);
  }

  return (
    <Step
      onSubmit={handleSubmit}
      component={() => <>{mobile && <WelcomeAboardIcon />}</>}
    />
  );
}
